import React, { useMemo, useState } from 'react';
import { array, func } from 'prop-types';
import { grid, gridItem, photo } from './styles/styles.module.scss';
import Lightbox from '../../shared/Lightbox';
import { urlReformatPhotos } from '../../../utils/lightbox_helpers';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { getPhotoUrl } from '../../../utils/photo_helper';

const PhotoGrid = ({ mapPhotos, mapId }) => {
  const [lightboxProps, updateLightboxProps] = useState({ isOpen: false, images: [], startingIndex: null });
  const sortedPhotos = useMemo(() => mapPhotos.sort((a, b) => new Date(a.photo.metadata.created) - new Date(b.photo.metadata.created)), [mapPhotos]);

  const openLightbox = startingIndex => {
    const photos = sortedPhotos.map(mp => mp.photo);
    const images = urlReformatPhotos(photos);

    updateLightboxProps(prevState => ({
      ...prevState,
      isOpen: true,
      images,
      startingIndex
    }));
  };

  const handleLightboxClose = () => {
    updateLightboxProps(prevState => ({ ...prevState, isOpen: false, images: [], startingIndex: null }));
  };

  const photos = sortedPhotos.map((mapPhoto, idx) => {
    const { id, hash } = mapPhoto.photo;
    const fallbackPhotoUrl = `/api/alltrails/photos/${id}/image?size=medium_square&key=${ServerCommunicationUtil.apiKey}`;
    const photoUrl = id && hash ? getPhotoUrl(id, hash, 'medium_square') : fallbackPhotoUrl;

    let shouldFallback = true;
    const addFallbackSrc = ev => {
      if (shouldFallback) {
        ev.target.src = fallbackPhotoUrl;
        ev.target.onerror = null;
      }
      shouldFallback = false;
    };

    return (
      <li key={`photo-${id}`} className={gridItem} onClick={() => openLightbox(idx)}>
        <img src={photoUrl} className={photo} alt="" onError={addFallbackSrc} />
      </li>
    );
  });

  return (
    <>
      <ul className={grid}>{photos}</ul>
      {lightboxProps.isOpen && <Lightbox {...lightboxProps} mapId={mapId} handleCloseRequest={handleLightboxClose} />}
    </>
  );
};

export default PhotoGrid;

PhotoGrid.propTypes = {
  mapPhotos: array.isRequired,
  handlePhotoClick: func
};

PhotoGrid.defaultProps = {
  handlePhotoClick: () => {}
};
